import React from 'react';

export default function StoryEditorSidebar() {
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <aside>
      <div className="description">Drag these elements and connect them to tell your story.</div>
      <div className="dndnode input" onDragStart={(event) => onDragStart(event, 'Scene')} draggable>
        Scene
      </div>
      <div className="dndnode" onDragStart={(event) => onDragStart(event, 'Alternative')} draggable>
        Alternative
      </div>
      <div
        className="dndnode output"
        onDragStart={(event) => onDragStart(event, 'Crossroads')}
        draggable
      >
        Crossroads
      </div>
    </aside>
  );
}
